const initSphThumbnailNavigation = () => {
  const lang = document.documentElement.lang.toLowerCase().split('-')[0];
  const captions = {
    nl: ['Vorige afbeeldingen', 'Volgende afbeeldingen'],
    en: ['Previous images', 'Next images'],
    de: ['Vorherige Bilder', 'Weitere Bilder'],
    fr: ['Images précédentes', 'Images suivantes'],
    es: ['Imágenes anteriores', 'Imágenes siguientes'],
    it: ['Immagini precedenti', 'Immagini successive'],
    pt: ['Imagens anteriores', 'Imagens seguintes'],
    ro: ['Imagini anterioare', 'Imagini următoare'],
    sv: ['Föregående bilder', 'Nästa bilder'],
    da: ['Forrige billeder', 'Næste billeder'],
    fi: ['Edelliset kuvat', 'Seuraavat kuvat'],
    no: ['Forrige bilder', 'Neste bilder'],
    nb: ['Forrige bilder', 'Neste bilder']
  };
  const labels = captions[lang] || captions.en;
  document.querySelectorAll('media-gallery.media-gallery--carousel slideshow-controls[thumbnails]').forEach(controls => {
    const scroller = controls.querySelector('.slideshow-controls__thumbnails-container');
    if (!scroller || controls.dataset.sphThumbNavigation) return;
    controls.dataset.sphThumbNavigation = '1';
    controls.classList.add('sph-thumb-navigation');
    const buttons = ['prev', 'next'].map(side => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sph-thumb-button sph-thumb-button--' + side;
      button.setAttribute('aria-label', side === 'prev' ? labels[0] : labels[1]);
      button.textContent = side === 'prev' ? '‹' : '›';
      button.hidden = true;
      button.addEventListener('click', event => {
        event.stopPropagation();
        scroller.scrollBy({ left: (side === 'prev' ? -1 : 1) * Math.max(120, scroller.clientWidth * .75), behavior: 'smooth' });
      });
      controls.appendChild(button);
      return button;
    });
    const update = () => {
      const end = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      const active = window.matchMedia('(min-width: 880px)').matches && end > 3;
      // All languages: check thumbnail edges, not just residual end padding.
      const viewport = scroller.getBoundingClientRect();
      const first = scroller.querySelector('.slideshow-controls__thumbnail');
      const last = scroller.querySelector('.slideshow-controls__thumbnail:last-child');
      const firstRect = first?.getBoundingClientRect();
      const lastRect = last?.getBoundingClientRect();
      const epsilon = 6;
      const left = Math.max(0, scroller.scrollLeft);
      const atStart = left <= epsilon || (firstRect && firstRect.left >= viewport.left - epsilon);
      const atEnd = end - left <= epsilon || (lastRect && lastRect.right <= viewport.right + epsilon);
      buttons[0].hidden = !active || atStart;
      buttons[1].hidden = !active || atEnd;
    };
    scroller.addEventListener('scroll', update, { passive: true });
    scroller.addEventListener('scrollend', update);
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(scroller);
    update();
  });
};

const startSphThumbnailNavigation = () => {
  initSphThumbnailNavigation();
  const observer = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches?.('media-gallery') || node.querySelector?.('media-gallery'))
    ))) initSphThumbnailNavigation();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', initSphThumbnailNavigation);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startSphThumbnailNavigation, { once: true });
} else {
  startSphThumbnailNavigation();
}
